import { defineComponent, mergeModels, ref, useModel, computed, onMounted, openBlock, createElementBlock, normalizeClass, createElementVNode, createVNode, unref, withCtx, createBlock, createTextVNode, createCommentVNode, getCurrentInstance } from "vue";
import { CdrButton, IconMinusStroke, CdrInput, IconPlusStroke } from "@rei/cedar";
import GenericErrorText from "../../GenericErrorText/GenericErrorText.mjs";
const _hoisted_1 = {
  class: "size-color__quantity-input-wrapper"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "BuyBoxQuantity",
  props: /* @__PURE__ */ mergeModels({
    error: {
      type: Boolean
    },
    quantity: {}
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["metricsClick", "registerRef", "qtyUpdate"], ["update:modelValue"]),
  setup(__props, {
    emit: __emit
  }) {
    const qtyInput = ref(null);
    const cachedInputElement = ref(null);
    const props = __props;
    const emit = __emit;
    const localQty = useModel(__props, "modelValue", {
      get: () => props.quantity,
      set: (newVal) => {
        if (!Number.isInteger(newVal) || newVal < 0) {
          cachedInputElement.value.value = props.quantity.toString();
        }
        handleQtyChange(newVal);
      }
    });
    const quantityWarning = computed(() => props.quantity >= 9999);
    const showMessaging = computed(() => {
      let val = null;
      if (props.error) val = "quantity-error-text";
      else if (quantityWarning.value) val = "quantity-warning-text";
      return val;
    });
    onMounted(() => {
      var _a, _b;
      const input = (_b = (_a = qtyInput == null ? void 0 : qtyInput.value) == null ? void 0 : _a.$el) == null ? void 0 : _b.querySelector("input");
      emit("registerRef", {
        type: "quantity",
        value: input
      });
      cachedInputElement.value = input;
    });
    const decrementQty = () => {
      handleQtyChange(props.quantity - 1);
    };
    const incrementQty = () => {
      handleQtyChange(props.quantity * 1 + 1);
    };
    const useForceUpdate = () => {
      const instance = getCurrentInstance();
      return () => {
        var _a;
        return (_a = instance == null ? void 0 : instance.proxy) == null ? void 0 : _a.$forceUpdate();
      };
    };
    const handleQtyChange = (newVal) => {
      let forceUpdate = false;
      let qty = Math.abs(Math.ceil(+newVal));
      if (+newVal > 9999) {
        qty = 9999;
        forceUpdate = true;
      }
      emit("qtyUpdate", +qty);
      emit("metricsClick", {
        linkName: "quantity"
      });
      if (forceUpdate) useForceUpdate();
    };
    const setMinValueToOne = () => {
      if (props.quantity === 0) handleQtyChange(1);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        id: "quantity-component",
        class: normalizeClass(["size-color__quantity", {
          "size-color__quantity--error": _ctx.error
        }])
      }, [_cache[3] || (_cache[3] = createElementVNode("div", {
        class: "size-color__quantity-label"
      }, " Quantity ", -1)), createElementVNode("div", _hoisted_1, [createVNode(unref(CdrButton), {
        id: "quantity-decrement",
        class: "size-color__quantity-btn size-color__quantity-btn--left",
        "aria-label": "Decrement Quantity",
        "aria-controls": "quantity-box",
        disabled: _ctx.quantity <= 1,
        "icon-only": true,
        onClick: decrementQty
      }, {
        icon: withCtx(() => [createVNode(unref(IconMinusStroke), {
          class: normalizeClass(["cdr-button__icon", {
            "cdr-button__icon--disabled": _ctx.quantity <= 1
          }]),
          "inherit-color": ""
        }, null, 8, ["class"])]),
        _: 1
      }, 8, ["disabled"]), createVNode(unref(CdrInput), {
        id: "quantity-box",
        ref_key: "qtyInput",
        ref: qtyInput,
        modelValue: localQty.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => localQty.value = $event),
        type: "number",
        label: "Quantity",
        class: "size-color__quantity-input",
        "aria-describedby": showMessaging.value,
        "aria-invalid": _ctx.error,
        max: "9999",
        min: "1",
        "hide-label": "",
        onBlur: setMinValueToOne
      }, null, 8, ["modelValue", "aria-describedby", "aria-invalid"]), createVNode(unref(CdrButton), {
        id: "quantity-increment",
        class: "size-color__quantity-btn",
        disabled: _ctx.quantity >= 9999,
        "icon-only": true,
        "aria-label": "Increment Quantity",
        "aria-controls": "quantity-box",
        onClick: incrementQty
      }, {
        icon: withCtx(() => [createVNode(unref(IconPlusStroke), {
          class: "cdr-button__icon",
          "inherit-color": ""
        })]),
        _: 1
      }, 8, ["disabled"])]), _ctx.error ? (openBlock(), createBlock(unref(GenericErrorText), {
        key: 0,
        id: "quantity-error-text",
        class: "size-color__quantity__error-text"
      }, {
        default: withCtx(() => _cache[1] || (_cache[1] = [createTextVNode(" Enter a quantity of 1 or more. ")])),
        _: 1,
        __: [1]
      })) : createCommentVNode("", true), quantityWarning.value ? (openBlock(), createBlock(unref(GenericErrorText), {
        key: 1,
        id: "quantity-warning-text",
        class: "size-color__quantity__error-text"
      }, {
        default: withCtx(() => _cache[2] || (_cache[2] = [createTextVNode(" Quantity must be 9,999 or less. ")])),
        _: 1,
        __: [2]
      })) : createCommentVNode("", true)], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=BuyBoxQuantity2.mjs.map
